import { Button } from 'antd';
import { forwardRef, useEffect, useRef, useState } from 'react';
import AntDraggableModal from '../../universal/AntDraggableModal';
import FilesSelector, { FilesSelectorProps } from './FilesSelector';
import BaseWebUniversal, { BaseWebUniversalProps } from '../system/BaseWebUniversal';
import { useMergedRef } from '../hooks/general';
import { CommonProps } from '../../../utilsTs/declareTypes';
import { BaseFilesProps } from './BaseFiles';

/** 文件扩展管理 */
export interface FilesExtendsManageProps extends
    Pick<BaseWebUniversalProps, 'apiId' | 'titleName' | 'columns' | 'editOptions' | 'sendPageData' | 'defaultService'>,
    Pick<CommonProps, 'closeModal'>,
    Pick<BaseFilesProps, 'insertFile' | 'defaultSelectedOptions'> {
    /** 文件组id */
    filesGroupId?: string;
};

/**
 * 文件扩展管理
 * @param props 
 * @returns 
 */
const FilesExtendsManage = forwardRef<any, FilesExtendsManageProps>((props, ref) => {

    const { apiId, titleName, columns, editOptions, closeModal, sendPageData } = props;
    const { Editor } = editOptions || {};
    const internalRef = useRef<any>(undefined);
    /** 合并外部 ref 和内部 refLocal */
    const mergedRef = useMergedRef(internalRef, ref);
    const [filesSelectorVisible, setFilesSelectorVisible] = useState<boolean>(false);

    useEffect(() => {

    }, []);


    /**
     * 扩展Props
     */
    const extendProps: BaseWebUniversalProps = {
        ...props,
        titleName: '文件组',
        apiId,
        columns,
        displayOptions: {
            showAdd: false,
            deleteButton: {
                useCheckBox: true,
                checkBoxContent: '删除无法恢复，小心删除！',
                isChecked: true
            }
        },
        editOptions: {
            Editor
        },
        renderHeadExtra: ({ rows, fetchData }) => (
            <>
                <Button type="primary" onClick={() => setFilesSelectorVisible(true)}>文件选择器</Button>
            </>
        )
    };

    const filesSelectorProps: FilesSelectorProps = {
        ...props,
        closeModal: (result) => {
            setFilesSelectorVisible(false);
            if (result?.success) {
                internalRef.current?.fetchData?.();
            }
        },
        titleName: '文件选择器',
        visible: filesSelectorVisible
    }

    return (
        <>
            <AntDraggableModal
                title={titleName}
                open={true}
                okText='退出'
                onOk={() => closeModal?.()}
                cancelButtonProps={{ style: { display: "none" } }}
                closable={false}
                maskClosable={false}
                width={1080}
            >
                <BaseWebUniversal {...extendProps} ref={mergedRef} />
            </AntDraggableModal>
            <FilesSelector  {...filesSelectorProps} />
        </>
    )
});

export default FilesExtendsManage;